import React, { useEffect, useState } from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardActionArea from '@mui/material/CardActionArea';
import CardActions from '@mui/material/CardActions';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import DescriptionIcon from '@mui/icons-material/Description';
import Loading from './loading';
import NewDoc from './Modals/NewDoc';
import ViewDoc from './Modals/ViewDoc';
import DecisionCheck from './Modals/DecisionCheck';

const Docs = ({ currentUser, socket, banner, setBanner }) => {

    const [reload, setReload] = useState(true);

    useEffect(() => {
        if (reload) {
            setBanner({ ...banner, loading: false, id: 0 });
            setReload(false);
            window.scrollTo(0, 0);
        }
    }, [setBanner, setReload, banner, reload]);

    const [loading, setLoading] = useState(true);

    const [docList, setDocList] = useState([]);

    const [check, setCheck] = useState({
        show: false,
        proceed: false,
        id: null
    });

    const [currentDoc, setCurrentDoc] = useState({
        show: false,
        data: null,
        loading: false,
    });

    if (loading) {
        let payload = {
            ip: localStorage.getItem('ip')
        }
        socket.emit('load docs', payload);
        socket.on('docs loaded', data => {
            setDocList(data);
            setLoading(false);
        });
    }

    const handleDelete = d => {
        setCheck({ proceed: false, id: d._id, show: true });
    }

    useEffect(() => {
        socket.on('doc stored', data => {
            setDocList({ ...docList, data });
        });
        socket.on('doc removed', data => {
            setDocList(docList.filter(d => d._id !== data._id));
        });
    }, [socket, docList]);

    return (
        <>
            {(!loading) ? (
                <>
                    <Card>
                        <CardContent sx={{ textAlign: 'center' }}>
                            <Typography variant="h5" gutterBottom>Documents</Typography>
                            <Grid container spacing={2} sx={{ mt: 1 }}>
                                {docList.length > 0 ? (
                                    docList.map(d => (
                                        <Grid key={d._id} size={{ xs: 6, sm: 4, md: 3 }}>
                                            <Card variant="outlined">
                                                <CardActionArea onClick={() => setCurrentDoc({ show: true, loading: true, data: d })}>
                                                    <CardContent sx={{ textAlign: 'center' }}>
                                                        <DescriptionIcon sx={{ fontSize: 40 }} />
                                                        <Typography variant="subtitle2" sx={{ mt: 1 }}>
                                                            {d.fileName.split(".")[0]}
                                                        </Typography>
                                                    </CardContent>
                                                </CardActionArea>
                                                {(currentUser.user.isAdmin > 8 && currentUser.adminSettings) && (
                                                    <CardActions sx={{ justifyContent: 'center' }}>
                                                        <Button color="error" size="small" onClick={() => handleDelete(d)}>Delete</Button>
                                                        <DecisionCheck
                                                            check={check}
                                                            setCheck={setCheck}
                                                            id={d._id}
                                                            socketName={'remove document'}
                                                            title={`Delete Document`}
                                                            body={`Are you sure you wish to delete this? This action cannot be undone.`}
                                                        />
                                                    </CardActions>
                                                )}
                                            </Card>
                                        </Grid>
                                    ))
                                ) : (
                                    <Grid size={12}>
                                        <Typography align="center" sx={{ mt: 5 }}>No documents currently exist.</Typography>
                                    </Grid>
                                )}
                            </Grid>
                        </CardContent>
                    </Card>
                    <NewDoc
                        currentUser={currentUser}
                        socket={socket}
                    />
                </>
            ) : (
                <Loading />
            )}
            <ViewDoc
                currentDoc={currentDoc}
                setCurrentDoc={setCurrentDoc}
                socket={socket}
            />
        </>
    );
};

export default Docs
